// extracted by mini-css-extract-plugin
module.exports = {"btn":"kycnavs_btn__12law"};